import { Image } from 'react-native';
import logoMark from '../../assets/logo-mark.png';
import logoWordmark from '../../assets/logo-wordmark.png';

/** Width ÷ height of logo-wordmark.png ("Khao Ddi" plus the 香港 seal). */
const WORDMARK_RATIO = 5.46;

export const LogoWordmark = ({ height = 36 }: { height?: number }) => (
  <Image accessibilityLabel="Khao Ddi" source={{ uri: logoWordmark }} style={{ height, width: height * WORDMARK_RATIO }} resizeMode="contain" />
);

export const LogoMark = ({ size = 40, opacity = 1 }: { size?: number; opacity?: number }) => (
  <Image accessibilityLabel="Khao Ddi" source={{ uri: logoMark }} style={{ width: size, height: size, opacity }} resizeMode="contain" />
);
